import { render, staticRenderFns } from "./PageChange.vue?vue&type=template&id=97809d18&"
import script from "./PageChange.vue?vue&type=script&lang=js&"
export * from "./PageChange.vue?vue&type=script&lang=js&"
import style0 from "./PageChange.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports